import { cn } from '@bem-react/classname';

export const cnKhHeader = cn('KhHeader');
